<span>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 536.4 166.5" xml:space="preserve" class="print_header-logo">
  <style type="text/css">
  .st0{fill:#002F87;}
  .st1{fill:#25B4BD;}
  .st2{fill:#3C3C3B;}
  </style>
  <g>
  <g>
    <path class="st0" d="M7.7,99.2l48.5-30.7C67,61.7,77.8,67,77.8,79v35.8c0,4.1,2.9,7,7.2,7h9.4c30.3,0,56.4-21.9,56.4-59.1
      C150.9,24.3,120.6,0,85,0H10.1C4.8,0,0,4.8,0,10.1v85.8C0,99.4,4.6,101.1,7.7,99.2"/>
    <path class="st1" d="M0,123v8.4c0,19,16.6,35.1,35.8,35.1h19.9c6.2,0,10.8-4.3,10.8-10.6V86c0-4.8-5-7.4-9.1-4.8L4.1,115.1
      C1,117,0,119.4,0,123"/>
  </g>
  <g>
    <g>
      <path class="st2" d="M236,78.8c0,10.7-6,17.8-20,17.8h-9.3v16.6h-13V60.8h22.3C229.8,60.8,236,67.7,236,78.8z M222.8,78.8
        c0-5-2.3-7.3-7.7-7.3h-8.5v14.7h8.5C220.6,86.1,222.8,83.3,222.8,78.8z"/>
      <path class="st2" d="M269.2,69.5v12.8c-1.6-0.3-3.1-0.5-4.6-0.4c-6.2,0-8.9,3.7-9.3,10.6v-0.1l-0.1,20.7h-12.4V69.8h9.3l2.5,8.6
        c2.1-5.7,6.6-9.3,11.9-9.2C267.8,69.2,268.5,69.3,269.2,69.5z"/>
      <path class="st2" d="M273.8,91.4c0-13.9,7-22.2,21.4-22.2c14.3,0,21.4,8.3,21.4,22.2c0,14.1-7,22.5-21.4,22.5
        S273.8,105.5,273.8,91.4z M303.7,91.3c0-8.3-2.5-12.1-8.4-12.1c-5.9,0-8.5,3.9-8.5,12.1c0,8,2.6,12.6,8.5,12.6
        C301.1,103.9,303.7,99.8,303.7,91.3z"/>
      <path class="st2" d="M361.9,69.8l-14.2,43.3h-14.1l-14.2-43.3h12.6l7.6,26.2c0.5,1.9,0.8,4,1.1,5.8c0.3-1.9,0.6-3.9,1-5.8
        l7.7-26.2H361.9z"/>
      <path class="st2" d="M366.3,58.1h12.4v8h-12.4V58.1z M366.3,69.8h12.4v43.3h-12.4V69.8z"/>
      <path class="st2" d="M428.2,84.5v28.7h-12.5V87.7c0-5.5-2-7.9-6.6-7.9c-5,0-7.9,2.9-8.3,9.4v24h-12.4V69.8h9.2l2.3,7.6
        c2.4-5.7,7.3-8.2,13.6-8.2C422.9,69.2,428.2,74.3,428.2,84.5z"/>
      <path class="st2" d="M435.2,91.5c0-13.8,7.6-22.3,22-22.3c6.9,0,11.4,2.1,15.3,4.8l-4,10.3c-2.9-3-6.2-4.6-10.3-4.6
        c-5.6,0-10.1,3.7-10.1,11.8s4.9,11.9,10.1,11.9c4.1,0,7.5-1.6,10.3-4.6l4,10.3c-3.9,2.6-8.4,4.8-15.3,4.8
        C443.1,113.9,435.2,105.3,435.2,91.5z"/>
      <path class="st2" d="M478.4,58.1h12.4v8h-12.4V58.1z M478.4,69.8h12.4v43.3h-12.4V69.8z"/>
      <path class="st2" d="M536.4,86.2v27h-9.2l-2.2-7.9c-2.1,5.3-6.8,8.6-13.9,8.6c-9.4,0-13-5.3-13-12.2c0-12.1,12.2-13.4,26.1-14.8
        v-0.2c0-5.4-3.7-7.5-9.4-7.5c-4.1,0-8.7,1.8-12.1,5.2l-5-9.2c4-3,10.3-5.8,18.4-5.8C530.2,69.3,536.3,75.3,536.4,86.2z
          M524.1,96.8v-3.1c-8,0.9-13.6,1.7-13.6,6.6c0,2.7,1.3,4.4,4.9,4.4C519.4,104.7,523.8,102.5,524.1,96.8z"/>
      <path class="st2" d="M216.6,158.3h-18.2l-2.7,7.9h-6.4l14-39.9h8.7l14,39.9h-6.8L216.6,158.3z M214.7,152.3l-6-17.7
        c-0.4-1.1-0.7-2.2-1.1-3.7c-0.4,1.6-0.8,2.7-1.1,3.7l-6,17.7H214.7z"/>
      <path class="st2" d="M246.1,150.9h-7.9v15.3h-6.4v-39.9h16.8c9.1,0,13.5,4.2,13.5,12.6c0,6.4-3.5,9.7-9.3,10.9
        c0.3,0.4,0.7,0.7,0.9,1.1l10.1,15.3h-7.6L246.1,150.9z M238.2,145.3h9.3c4.8,0,8-1,8-6.4c0-5.2-3.1-6.5-8-6.5h-9.3V145.3z"/>
      <path class="st2" d="M297.6,132.1h-12.5v34.1h-6.4v-34.1h-12.7v-5.8h31.6V132.1z"/>
    </g>
  </g>
  </g>
  </svg>
</span>
